export const UploadIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M30.824 16.688c6.75.58 9.507 4.05 9.507 11.643v.244c0 8.381-3.357 11.738-11.738 11.738H16.387c-8.381 0-11.738-3.357-11.738-11.738v-.244c0-7.537 2.72-11.006 9.357-11.625M22.5 28.125V6.788m6.28 4.181L22.5 4.688l-6.282 6.28"
      stroke="#0e966f"
      strokeWidth="3.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
